<div class="cards-container">
  <ng-container *ngFor="let card of cards">
    <div class="card"
         (click)="filterCard(card)"
         [class.clickable]="card.isCardClickable"
         tabindex="0"
         (keydown.enter)="filterCard(card)"
         [ngStyle]="card.colorBorder ? {'border-left': '4px solid ' + card.colorBorder} : {'border-left': 'none'}">
      <div class="content-card-avaliacao">
        <div class="card-info">
          <div class="card-title">{{card.title}} {{card.qtdDescription}}</div>
          <div class="p-content">
            <span class="qtd">{{card.quantidade}}</span>
          </div>
        </div>
        <div *ngIf="card.icon" class="icon-container"
             [ngStyle]="card.colorBorder ? {'background': colorAlpha(card.colorBorder, 0.05)} : {'background': '#ededed'}">
          <em class="{{card.icon}}"
              [ngStyle]="card.colorBorder ? {'color': card.colorBorder} : {'color': '#888'}"></em>
        </div>
      </div>
    </div>
  </ng-container>
</div>
